import { render, staticRenderFns } from "./sendConfigList.vue?vue&type=template&id=1e9871c0&scoped=true"
import script from "./sendConfigList.vue?vue&type=script&lang=js"
export * from "./sendConfigList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e9871c0",
  null
  
)

export default component.exports